module.exports = __webpack_public_path__ + "img/minus_button.1ce3f092.svg";